import { useParams } from 'react-router';
import { useFetchPermissions } from '../hooks/usePermissions';
import { PatientsList } from '../components/PatientsList/PatientsList';
import styles from './PatientsPage.module.css';

// Patients moved out of settings into the main navigation: entering a new
// patient and looking up preferences is daily planning work, not configuration.
export const PatientsPage = () => {
  const { locationId } = useParams<{ locationId: string }>();
  useFetchPermissions(locationId);

  return (
    <main className={styles.patientsPage}>
      <PatientsList />
    </main>
  );
};
